export enum TypeCampaign {
  BLASTING = 'BLASTING',
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  WHATSAPP = 'WHATSAPP',
  PREVIEW = 'PREVIEW',
}
